export default __webpack_public_path__ + "static/media/news.8134a7e4.svg";